import React, { useState, useEffect, useCallback } from 'react';
import Script from 'next/script';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { shared } from '../../config';
import { BRIGHTBACK_CANCEL_KEY, useExperiment } from '../../experiments';
import { CancelAnchor } from './styles';

export const BrightbackCancelButton = ({
  customerId,
  customerEmail,
  petSubscriptionId,
}) => {
  const [cancelUrl, setCancelUrl] = useState(null);
  const [isBrightbackInitiated, setIsBrightbackInitiated] = useState(false);
  const router = useRouter();
  const { value: showBrightbackButton } = useExperiment(
    BRIGHTBACK_CANCEL_KEY,
    false,
  );

  const handleOnScriptLoad = useCallback(() => {
    const { Brightback } = window;
    if (Brightback && !isBrightbackInitiated) {
      Brightback.handleDataPromise({
        app_id: shared.BRIGHTBACK_APP_ID,
        subscription_id: petSubscriptionId,
        email: customerEmail,
        account: {
          internal_id: customerId,
        },
      }).then(resp => {
        if (!!resp.valid) {
          setCancelUrl(resp.url);
          setIsBrightbackInitiated(true);
        }
      });
    }
  }, [customerId, customerEmail, petSubscriptionId, isBrightbackInitiated]);

  useEffect(() => {
    const routeChangeHandler = () => handleOnScriptLoad();
    router.events.on('routeChangeComplete', routeChangeHandler);
    return () => router.events.off('routeChangeComplete', routeChangeHandler);
  }, [router.events, handleOnScriptLoad]);

  if (!showBrightbackButton) return null;

  return (
    <>
      <Script
        id="brightback-script"
        type="text/javascript"
        src="https://app.brightback.com/js/current/brightback.js?compiled=true"
        strategy="afterInteractive"
        onLoad={handleOnScriptLoad}
      />
      <CancelAnchor href={cancelUrl} target="_blank">
        Cancel Subscription
      </CancelAnchor>
    </>
  );
};

BrightbackCancelButton.propTypes = {
  customerId: PropTypes.number.isRequired,
  customerEmail: PropTypes.string.isRequired,
  petSubscriptionId: PropTypes.string.isRequired,
};
